export default __webpack_public_path__ + "static/media/bracket-right.cce75f05.svg";